import { IMsgFragmentNewChild } from "../Interfaces";



export class MsgFragmentNewChild {

    private msgFragmentNewChild: IMsgFragmentNewChild;

    constructor(msgFragmentNewChild: IMsgFragmentNewChild) {
        this.msgFragmentNewChild = msgFragmentNewChild;
    }

    /**
	 * returns IMsgFragmentNewChild
	 * @returns { IMsgFragmentNewChild }
	 */
	public get = (): IMsgFragmentNewChild => {
		return { ...this.msgFragmentNewChild };
	}

}